import router from '@/router'

export default {
    getDprs: (state) => state.dpr,
    getDprFiles:(state) => state.dprFiles || [],
    getCurrentDprMainId: (state) => router.currentRoute.params.dprMainId || state.currentDprMainId,
    getDprPVId: (state) => router.currentRoute.query.pvId || state.currentPVId
}